import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["option"];
  static values = { exclusive: String };

  change({ target }) {
    if (!target.checked) return;

    this.optionTargets.forEach((option) => {
      if (option === target) return;
      if (target.value === this.exclusiveValue || option.value === this.exclusiveValue) option.checked = false;
    });
  }
}
